import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Chakra imports
import {
  Flex,
  Heading,
  Table,
  TableContainer,
  Thead,
  Th,
  Tr,
  Td,
  Text,
  Tbody,
  Select,
  Badge,
  Box,
  Input,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import { BsEye } from "react-icons/bs";
import moment from "moment";
import { getAllPublish } from "service/publish.service";
import { usePaginateComponent } from "components/Pagination/pagination";
import { PUBLISHABLE_TYPE_COLOR } from "constants";
import { PUBLISH_STATUS_COLOR } from "constants";

export default function publishes() {
  //variables
  const history = useHistory();
  const [publish, setPublish] = useState([]);
  const [searchPublish, setSearchPublish] = useState("");
  const [publishableType, setPublishableType] = useState("");
  const [publishableStatus, setPublishableStatus] = useState("");

  const {pagination, setPagination, PaginationComponent, updatePagination} = usePaginateComponent()


  //methods
  const getPublish = async (page) => {
    try {
      const { data } = await getAllPublish(page ?? 1, 50, searchPublish, publishableType, publishableStatus);

      setPagination(updatePagination(data));

      setPublish(data.data);

      window.scrollTo({ top: 80, behavior: "smooth" });
    } catch (error) {
      console.log(error);
    }
  };

  //setup methods
  useEffect(() => {
    getPublish();
  }, [searchPublish, publishableType, publishableStatus]);

  //component
  // console.log('publish in before return', publish.data);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card>
        <CardHeader my={"4"}>
          {/* <Heading>publishes Table</Heading> */}
          <Box p={"2"} w={"full"}>
            <Input
              placeholder={"Search. . ."}
              onChange={(e) => {
                setSearchPublish(e.target.value);
              }}
              textColor={"black"}
              bg={"white"}
            />
          </Box>
          <PaginationComponent pagination={pagination} getListData={getPublish} />
        </CardHeader>

        <CardBody>
          <TableContainer
            overscroll={"auto"}
            maxH={"xl"}
            overflowY="scroll"
            position="relative"
            w={"full"}
          >
            <Table>
              <Thead
                position="sticky"
                top="0"
                zIndex="sticky"
                bg="gray.900"
                color="whiteAlpha.900"
              >
                <Tr>
                  {/*              Publish Detail           */}
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Date Created
                    </Text>
                  </Th>
                  {/* <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      
                    >
                      Date Created
                    </Text>
                  </Th> */}
                  <Th>
                    <Select
                      placeholder="Resource Type"
                      fontSize={"x-small"}
                      fontWeight={"bold"}
                      textTransform={"uppercase"}
                      textColor={"whiteAlpha.900"}
                      onChange={(e) => {
                        setPublishableType(e.target.value);
                      }}
                    >
                      {Object.keys(PUBLISHABLE_TYPE_COLOR).map((key) => (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      ))}
                    </Select>
                  </Th>
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Resource Name
                    </Text>
                  </Th>
                  {/* <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Publish Status
                    </Text>
                  </Th> */}
                  <Th>
                    <Select
                      placeholder="Publish Status"
                      fontSize={"x-small"}
                      fontWeight={"bold"}
                      textTransform={"uppercase"}
                      textColor={"whiteAlpha.900"}
                      onChange={(e) => {
                        setPublishableStatus(e.target.value);
                      }}
                    >
                      {Object.keys(PUBLISH_STATUS_COLOR).map((key) => (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      ))}
                    </Select>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {publish &&
                  publish.map((publishes, index) => {
                    return (
                      <Tr
                        textColor={"whiteAlpha.900"}
                        fontSize={"small"}
                        key={index}
                        onClick={() => {
                          history.push({
                            pathname: `/admin/publish/detail`,
                            state: publishes,
                          });
                        }}
                        _hover={{ bg: "blue.900", cursor: "pointer" }}
                        position={"relative"}
                      >
                        {/*              Publish Detail           */}
                        <Td>
                          <Text>
                            {publishes?.created_at
                              ? moment(publishes?.created_at).format("YYYY-MM-DD")
                              : ""}
                          </Text>
                        </Td>
                        <Td>
                          <Badge
                            bg={
                              PUBLISHABLE_TYPE_COLOR[publishes?.publishable_type] ??
                              "black"
                            }
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {publishes?.publishable_type}
                          </Badge>
                        </Td>
                        {/* <Td >
                          <Text>
                            {publishes?.complete_date
                              ? moment(publishes?.complete_date).format("YYYY-MM-DD")
                              : ""}
                          </Text>
                        </Td> */}
                        <Td>
                          {publishes?.publishable_type == "job"
                            ? publishes?.publishable?.title
                            : publishes?.publishable?.name}
                        </Td>
                        <Td>
                          <Badge
                            bg={PUBLISH_STATUS_COLOR[publishes?.status] ?? "black"}
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {publishes?.status}
                          </Badge>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Flex>
  );
}
